import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

export const getAllCategoriesThunk = createAsyncThunk(
  'categories/getCategories',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllCategory(config);
      return response.data;
    } catch (error) {
      console.log(error);


    }
  }
);

export const deleteCategoriesThunk = createAsyncThunk(
  'categories/deleteCategories',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deleteCategory(id);
      dispatch(setCategoryRefresh())
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);


export const deletemultipleCategoriesThunk = createAsyncThunk(
  'categories/deletemultipleCategoriesThunk',
  async (id, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.deletemultipleCategory(id);
      dispatch(setCategoryRefresh())
      dispatch(setSelectAllCat(false))
      dispatch(setSelectedIds([]))
      toast.success(response.data?.data?.message || 'Data deleted successfully')
      return response.data?.data;

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "something went wrong")
    }
  }
);

export const updateCategory = createAsyncThunk(
  'category/updateCategory',
  async (categoryData, { rejectWithValue }) => {
    try {
      const { data, status } = await api.updateCategory(categoryData);
      toast.success(data?.data?.message)
      return status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')

      return rejectWithValue(error.response.data);
    }
  }
);

export const exportCategoryThunk = createAsyncThunk(
  'categories/exportcategory',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.exportCategory(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

// Slice for categories
const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    refresh: false,
    filteredCategories: [],
    loading: false,
    error: null,
    editCategory: null,
    exportedData: [],
    exportLoading:false,
    page:1,
    selectedIds:[],
    selectAll:false
  },
  reducers: {
    setCategories: (state, action) => {
      state.filteredCategories = action.payload
    },
    setCategoryRefresh: (state, action) => {
      state.refresh = !state.refresh;
    },
    setEditCategory: (state, action) => {
      state.editCategory = action.payload;
    },
    setCategoriesPage:(state,action)=>{
      state.page = action.payload
    },
    setSelectedIds:(state,action)=>{
      state.selectedIds = action.payload
    },
    setSelectAllCat:(state,action) =>{
      state.selectAll = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getAllCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //delete
      .addCase(deleteCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(deleteCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      //upadate
      .addCase(updateCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.editCategory = null;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //export category
      .addCase(exportCategoryThunk.pending, (state) => {
        state.exportLoading = true;
        state.error = null;
      })
      .addCase(exportCategoryThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
        state.exportedData = action.payload;
      })
      .addCase(exportCategoryThunk.rejected, (state, action) => {
        state.exportLoading = false;
        state.error = action.payload;
      })
  },
});

export const { setCategories, setCategoryRefresh, setEditCategory ,setCategoriesPage,setSelectedIds,setSelectAllCat} = categoriesSlice.actions
export default categoriesSlice.reducer;

